export default __webpack_public_path__ + "static/media/oh-du-goldigs-suenneli.09dc872c.pdf";